import React, { FC } from 'react'

import { IconKippyDeviceProps } from './IconKippyDevice.types'
import * as Styled from './styles/IconKippyDevice.style'

import { nonThemeableRules } from '../../ruleSet'

const IconKippyDevice: FC<IconKippyDeviceProps> = ({
  size = nonThemeableRules.defaultSize as number as IconKippyDeviceProps['size'],
  isResponsive = false,
}: IconKippyDeviceProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M16.25 11.012h15.5c6.215 0 11.25 5.039 11.25 11.25v3.547c0 6.214-5.035 11.25-11.25 11.25h-15.5C10.035 37.059 5 32.023 5 25.809v-3.547c0-6.211 5.035-11.25 11.25-11.25Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M15.586 15.063 35 15.03v15.024a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V18.03a3 3 0 0 1 3-3'
          stroke='#fff'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='M24.79 27.113c.792-1 1.886-2.71 1.886-4.172 0-1.562-1.125-2.878-2.676-2.878-1.55 0-2.676 1.25-2.676 2.832 0 2.19 2.676 5.16 2.676 5.16s.594-.703.79-.942Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconKippyDevice
